import { createDraftSafeSelector } from "@reduxjs/toolkit";

import { RootState } from "../../configureStore";

const selectState = (state: RootState) => state.rateHistoryModal;

const makeSelectOpen = createDraftSafeSelector(selectState, (state) => state.open);
const makeSelectRateId = createDraftSafeSelector(selectState, (state) => state.rateId);
const makeSelectCalculationVehicleId = createDraftSafeSelector(selectState, (state) => state.calculationVehicleId);
const makeSelectCarrierName = createDraftSafeSelector(selectState, (state) => state.carrierName);
const makeSelectActiveTab = createDraftSafeSelector(selectState, (state) => state.activeTab);
const makeSelectItems = createDraftSafeSelector(selectState, (state) => state.items);
const makeSelectTotal = createDraftSafeSelector(selectState, (state) => state.total);
const makeSelectPage = createDraftSafeSelector(selectState, (state) => state.page);
const makeSelectPageSize = createDraftSafeSelector(selectState, (state) => state.pageSize);
const makeSelectLoading = createDraftSafeSelector(selectState, (state) => state.loading);
const makeSelectLoadingMore = createDraftSafeSelector(selectState, (state) => state.loadingMore);
const makeSelectError = createDraftSafeSelector(selectState, (state) => state.error);
const makeSelectCreateError = createDraftSafeSelector(selectState, (state) => state.createError);
const makeSelectCreatingRateId = createDraftSafeSelector(selectState, (state) => state.creatingRateId);

export {
  selectState,
  makeSelectOpen,
  makeSelectRateId,
  makeSelectCalculationVehicleId,
  makeSelectCarrierName,
  makeSelectActiveTab,
  makeSelectItems,
  makeSelectTotal,
  makeSelectPage,
  makeSelectPageSize,
  makeSelectLoading,
  makeSelectLoadingMore,
  makeSelectError,
  makeSelectCreateError,
  makeSelectCreatingRateId,
};
